import React from 'react'
import './Contact.css'
import Navbar from './../Components/Navbar/LanNavbar'
import { BrowserView, MobileView} from 'react-device-detect';
import logo from "./../Assets/Vector.png"
import burger from "./../Assets/icon.png"

function Contact() {

    const observer = new IntersectionObserver((enteries) => {
        enteries.forEach((entry) => {
          console.log(entry);
          if(entry.isIntersecting){
            entry.target.classList.add('show');
          }
        })
      })
    
      setTimeout(() => {
      const hiddenElements = document.querySelectorAll('.hidden');
      hiddenElements.forEach((el) => observer.observe(el));
      });


    return (
        <div id='contact_us'>
            <BrowserView>
                <Navbar/>
                <div className='contact_container hidden'>
                    <h1>Contact us</h1>
                    <h2>Got any questions? Don't hesitate to reach out.</h2>
                    <div className='name_email_box'>
                        <div className='name_box'>
                            <h3>Full name</h3>
                            <input placeholder='First name' type='text'/>
                        </div>
                        <div className='name_box'>
                            <h3>Email Address</h3>
                            <input placeholder='Email Address' type='email'/>
                        </div>
                    </div>
                    <div className='message_box'>
                        <textarea className='message_email' placeholder='Your message'/>
                    </div> 
                    <button>Submit</button>
                </div> 
            </BrowserView> 
            <MobileView>
                <div className='mob_lannav'>
                    <img className='mob_lannav_logo' src={logo}/>
                    <img className='mob_lannav_burger' src={burger}/>
                </div>
                <div className='mob_contact_container hidden'>
                    <h1>Contact us</h1>
                    <h2>Got any questions? Don't hesitate to reach out.</h2>
                    <div className='mob_name_email_box'>
                        <div className='name_box'>
                            <h3>Full name</h3>
                            <input placeholder='First name' type='text'/>
                        </div>
                        <div className='name_box'>
                            <h3>Email Address</h3>
                            <input placeholder='Email Address' type='email'/>
                        </div>
                    </div>
                    <div className='mob_message_box'>
                        <textarea className='mob_message_email' placeholder='Your message'/>
                    </div> 
                    <button>Submit</button>
                </div> 
            </MobileView>
        </div>
    )
}

export default Contact
